import { SagaIterator } from "redux-saga"
import { call, put, fork, take, takeEvery, cancel, cancelled } from "redux-saga/effects"
import * as planningTimeslotActions from "app/redux/planningTimeslots/planningTimeslots.actions"
import { createWebSocketConnectionForTimeslots } from "app/webSockets/webSockets"
import { createSocketChannel, createStatusChannel, joinRoom } from "app/webSockets/channels"
import { Socket } from "socket.io-client"
import { PlanningTimeslotsChannelPayload } from "./planningTimeslotsChannel.reducer"
import * as actions from "./planningTimeslotsChannel.actions"

function* reportStatus(statusChannel: any) {
  while (true) {
    const status = yield take(statusChannel)
    yield put(actions.connectionTimeslotsChannelStatus(status))
  }
}

function* writeAndReadSocket(socket: Socket, payload: PlanningTimeslotsChannelPayload) {
  const readerChannel = yield call(createSocketChannel, socket)
  const statusChannel = yield call(createStatusChannel, socket)
  try {
    yield fork(reportStatus, statusChannel)
    joinRoom(socket, payload)
    yield put(actions.connectionTimeslotsChannelSuccess())
    while (true) {
      const { timeslots } = yield take(readerChannel)
      yield put(planningTimeslotActions.getPlanningTimeslotsSuccess(timeslots))
    }
  } catch (error) {
    yield put(actions.connectionTimeslotsChannelFail(error))
  } finally {
    statusChannel.close()
    if (yield cancelled()) {
      socket.disconnect()
      readerChannel.close()
      yield put(actions.disconnectTimeslotsChannelSuccess())
    } else {
      yield put(actions.disconnectTimeslotsChannelFail(new Error("disconnected")))
    }
  }
}

function* listen(action: actions.ConnectTimeslotsChannelAction) {
  const socket = yield call(createWebSocketConnectionForTimeslots)
  const w = yield fork(writeAndReadSocket, socket!, action.payload)

  yield take(actions.Types.DISCONNECT)
  yield cancel(w)
}

export default function* timeslotsChannelSaga(): SagaIterator {
  yield takeEvery([actions.Types.CONNECT], listen)
}
